import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { QuestState } from '~/components/QuestPanel/type'
import { RootState } from '~/redux/store'

interface State {
  questState: QuestState
  isNewQuest: boolean
  clickedQuest: string
  resize: boolean
  skipingToBoss: boolean
}

const initialQuestState = {
  questName: '',
  questRewards: {
    kudos: 0,
    gems: 0,
    xp: 0,
  },
  showCompletedQuestModal: false,
}

const initialState: State = {
  questState: initialQuestState,
  isNewQuest: false,
  clickedQuest: '',
  resize: false,
  skipingToBoss: false,
}

const slice = createSlice({
  name: 'quest-state',
  initialState,
  reducers: {
    setQuestState: (state, action: PayloadAction<QuestState>) => ({
      ...state,
      questState: action.payload,
    }),
    resetQuestState: (state) => ({
      ...state,
      questState: initialQuestState,
    }),
    setIsNewQuest: (state, action: PayloadAction<boolean>) => ({
      ...state,
      isNewQuest: action.payload,
    }),
    setClickedQuest: (state, action: PayloadAction<string>) => ({
      ...state,
      clickedQuest: action.payload,
    }),
    setResize: (state, action: PayloadAction<boolean>) => ({
      ...state,
      resize: action.payload,
    }),
    setSkipingToBoss: (state, action: PayloadAction<boolean>) => ({
      ...state,
      skipingToBoss: action.payload,
    }),
  },
})

export const selectQuestState = (state: RootState): QuestState => state.quest.questState
export const selectIsNewQuest = (state: RootState): boolean => state.quest.isNewQuest
export const selectClickedQuest = (state: RootState): string => state.quest.clickedQuest
export const selectResize = (state: RootState): boolean => state.quest.resize
export const selectSkipingToBoss = (state: RootState): boolean => state.quest.skipingToBoss
export const { setQuestState, resetQuestState, setIsNewQuest, setClickedQuest, setResize, setSkipingToBoss } =
  slice.actions

export default slice.reducer
